import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div 
        className="hero-background" 
        style={{ transform: `translateY(${scrollY * 0.5}px)` }}
      ></div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-text">Est. September 2023</span>
        </div>
        
        <h1 className="hero-title">
          Authentic Caribbean Meals
          <span className="hero-title-accent">Delivered to Your Family</span>
        </h1>
        
        <p className="hero-description">
          Family-owned food manufacturing facility in Newnan, Georgia. Founded in September 2023, 
          we produce carefully crafted Caribbean-style frozen dinners, bringing authentic meals to families across the US and globally soon.
        </p>
        
        <div className="hero-actions">
          <button className="btn-primary" onClick={scrollToProducts}>
            Explore Our Menu
          </button>
          <button className="btn-secondary" onClick={() => document.getElementById('story').scrollIntoView({ behavior: 'smooth' })}>
            Our Story
          </button>
        </div>

        <div className="hero-features">
          <div className="feature-item">
            <div className="feature-icon">✓</div>
            <span>USDA Certified</span>
          </div>
          <div className="feature-item">
            <div className="feature-icon">✓</div>
            <span>Family-Owned</span>
          </div>
          <div className="feature-item">
            <div className="feature-icon">✓</div>
            <span>Authentic Recipes</span>
          </div>
        </div>
      </div>
      
      <button className="scroll-indicator" onClick={scrollToProducts}>
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;
